<template>
    <el-card>
        <template #header>
            <content-header />
        </template>

        <!-- <search-form ref="searchForm" :fields="search"/>
    <button-link type="success" to="/admin-permissions/create">
      <slot>添加</slot>
    </button-link> -->

        <div class="header-button">
            <search-form ref="searchForm" :fields="search" />
            <div class="selections">
                <button-link type="success" to="/admin-permissions/create">
                    <slot>添加权限</slot>
                </button-link>

                <!-- <el-button type="primary" @click="addAdvertisement">添加广告</el-button> -->
            </div>
        </div>
        <el-table :data="perms" resource="admin-permissions">
            <!--<el-table-column prop="id" label="ID" width="60"/>-->
            <el-table-column prop="name" label="名称" width="150" />
            <el-table-column prop="slug" label="标识" width="150" />
            <el-table-column label="路由" min-width="400">
                <template #default="{ row }">
                    <route-show :data="row" />
                </template>
            </el-table-column>
            <el-table-column prop="created_at" label="添加时间" width="180" />
            <el-table-column prop="updated_at" label="修改时间" width="180" />
            <el-table-column label="操作" width="150">
                <template #default="{ row, $index }">
                    <el-button-group>
                        <row-to-edit />
                        <row-destroy />
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <div class="card-footer">
            <pagination :page="page" />
        </div>
    </el-card>
</template>

<script>
import { getAdminPerms } from "@/api/admin-perms";
import RouteShow from "./components/RouteShow";
import Pagination from "@c/Pagination";
import SearchForm from "@c/SearchForm";
import RowDestroy from "@c/LzTable/RowDestroy";
import RowToEdit from "@c/LzTable/RowToEdit";
import ButtonLink from "@c/ButtonLink";
import { mixinsAutoPageSize } from "@/libs/utils";

export default {
    name: "Index",
    components: {
        RowToEdit,
        RowDestroy,
        SearchForm,
        Pagination,
        RouteShow,
        ButtonLink,
    },
    data() {
        return {
            perms: [],
            page: null,
            searchForm: {},
            first_blood: true,
            search: [
                {
                    field: "id",
                    label: "ID",
                },
                {
                    field: "name",
                    label: "名称",
                },
                {
                    field: "slug",
                    label: "标识",
                },
                {
                    field: "http_path",
                    label: "请求路径",
                },
            ],
        };
    },
    mixins: [mixinsAutoPageSize],
    watch: {
        $route: {
            async handler(newVal) {
                await this.autoPageSize(53, newVal);
                const {
                    data: { data, meta },
                } = await getAdminPerms(newVal.query);
                this.perms = data;
                this.page = meta;
            },
            immediate: true,
        },
    },
};
</script>
<style lang="scss">
.header-button {
    display: flex;
    justify-content: space-between;
    .selections {
        display: inline-block;
        margin-right: 10px;
    }
}
</style>
